import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    api.get(`/public/blogs/${slug}`).then(({ data }) => setPost(data)).catch(() => setMissing(true));
  }, [slug]);

  return (
    <div className="navy-bg min-h-screen pt-32 pb-24" data-testid="blog-post-page">
      <div className="max-w-3xl mx-auto px-6">
        <Link to="/blog" className="text-sm text-slate-300 hover:text-white flex items-center gap-1.5 mb-10" data-testid="blog-back-link">
          <ArrowLeft className="w-4 h-4" /> All posts
        </Link>
        {missing ? (
          <p className="text-slate-300" data-testid="blog-not-found">This post does not exist or is not published.</p>
        ) : !post ? (
          <p className="text-slate-400">Loading…</p>
        ) : (
          <article>
            <p className="text-xs text-slate-400 mb-3">
              {new Date(post.created_at).toLocaleDateString("en-IN", { day: "2-digit", month: "long", year: "numeric" })} · {post.author}
            </p>
            <h1 className="font-heading text-3xl sm:text-4xl font-bold text-white mb-8" data-testid="blog-post-title">{post.title}</h1>
            <div className="text-slate-200 leading-relaxed whitespace-pre-wrap" data-testid="blog-post-body">{post.body}</div>
          </article>
        )}
      </div>
    </div>
  );
}
